import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { IGridTwoColumnBlock } from './grid-two-column.model';
import { NgClass } from '@angular/common';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { computedGridColumnClasses } from '../grid.utils';
import { gridInputTransform } from '../grid-input.transform';

@Component({
    selector: 'div[s1-grid-two-column]',
    imports: [CmsComponent, NgClass],
    templateUrl: './grid-two-column.component.html',
    styleUrl: './grid-two-column.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'grid grid-cols-12',
        '[class]': 'classes()',
    }
})
export class GridTwoColumnComponent {
    private _tailwind = inject(TailwindService);

    // @ts-expect-error - transform works - fix later typing
    block = input.required<IGridTwoColumnBlock>({transform: gridInputTransform<IGridTwoColumnBlock>});
    classes = computed(() => {
        const block = this.block();
        return [
            ...this._tailwind.getGapClasses(block),
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getDisplayClasses(block, 'grid'),
        ];
    });

    column1Classes = computed(() => {
        return this._tailwind.getColSpanClasses(computedGridColumnClasses(1, this.block()));
    });

    column2Classes = computed(() => {
        return this._tailwind.getColSpanClasses(computedGridColumnClasses(2, this.block()));
    });
}
